// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FullScreenView__fullScreen-e9ba18 {
  display: flex;
}

.FullScreenView__container-afacea {
  display: flex;
  flex: 1;
  position: relative;
  width: 100%;
  background: var(--addition-40);
  height: 100%;
  box-sizing: border-box;
  justify-content: center;
}

.FullScreenView__main-e43c21 {
  padding: 8px;
  position: relative;
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.FullScreenView__streamers-bb41fa {
  position: relative;
}

.FullScreenView__speaker-cc047e {
  position: relative;
  display: flex;
  flex: 1;
}

.FullScreenView__meta-c1d98c {
  top: 8px;
}

.FullScreenView__secondary-f503ad {
  position: absolute;
  top: 64px;
  inset-inline-end: 8px;
  border-radius: 8px;
  overflow: hidden;
}

.FullScreenView__secondary-f503ad > div {
  overflow: visible;
}

.FullScreenView__secondary-f503ad video {
  width: 100% !important;
  max-width: 240px;
  height: auto !important;
  position: static !important;
  vertical-align: bottom;
}

.FullScreenView__button-f15c87 {
  margin-top: 20px;
}

.FullScreenView__waiting-b8fc9a,
.FullScreenView__connecting-c56d30,
.FullScreenView__canceled-ff1b39,
.FullScreenView__finished-ad45d1,
.FullScreenView__started-e433c3,
.FullScreenView__published-c14831 {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--addition-40_60);
  font: var(--font-title-9);
  letter-spacing: var(--font-spacing-title-9);
  color: var(--addition-50);
}

.FullScreenView__finished-ad45d1 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
}

.FullScreenView__finish-title-d8de29 {
  margin-bottom: 12px;
  color: var(--addition-50);
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
}

.FullScreenView__finish-caption-f3650d {
  display: flex;
  align-items: center;
}

.FullScreenView__finish-icon-af18d0 {
  margin-inline-end: 4px;
  fill: currentColor;
}

.FullScreenView__finish-actions-e84977 {
  margin-top: 34px;
  display: flex;
  flex-direction: column;
}

.FullScreenView__publish-button-cd48e5 {
  margin-bottom: 26px;
}

.FullScreenView__published-title-d537fa {
  font: var(--font-title-6);
  color: var(--addition-50);
  margin-bottom: 8px;
}

.FullScreenView__published-description-d02cf6 {
  font: var(--font-body-5);
  color: var(--addition-50);
  margin-bottom: 24px;
}

.FullScreenView__waiting-b8fc9a > div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font: var(--font-title-1);
  letter-spacing: var(--font-spacing-title-1);
  color: var(--addition-50);
  visibility: hidden;
  animation: FullScreenView__countdown-ea4c09 1s linear forwards;
}

.FullScreenView__waiting-b8fc9a > div:nth-child(2) {
  animation-delay: 1s;
}

.FullScreenView__waiting-b8fc9a > div:nth-child(3) {
  animation-delay: 2s;
}

.FullScreenView__close-button-c3f0da {
  margin-top: 24px;
}

@keyframes FullScreenView__countdown-ea4c09 {
  from {
    visibility: visible;
  }
  to {
    visibility: hidden;
  }
}
.FullScreenView__started-e433c3 {
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/InitiatorView/FullScreenView/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,OAAA;AACF;;AAEA;EACE,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;;;;;;EAME,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,yBAAA;EACA,2CAAA;EACA,yBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,2CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,2CAAA;EACA,yBAAA;EACA,kBAAA;EACA,8DAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE;IACE,mBAAA;EACF;EACA;IACE,kBAAA;EACF;AACF;AAEA;EACE,yBAAA;EACA,2CAAA;AAAF","sourcesContent":[".fullScreen {\n  display: flex;\n}\n\n.container {\n  display: flex;\n  flex: 1;\n  position: relative;\n  width: 100%;\n  background: var(--addition-40);\n  height: 100%;\n  box-sizing: border-box;\n  justify-content: center;\n}\n\n.main {\n  padding: 8px;\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n}\n\n.streamers {\n  position: relative;\n}\n\n.speaker {\n  position: relative;\n  display: flex;\n  flex: 1;\n}\n\n.meta {\n  top: 8px;\n}\n\n.secondary {\n  position: absolute;\n  top: 64px;\n  inset-inline-end: 8px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.secondary > div {\n  overflow: visible;\n}\n\n.secondary video {\n  width: 100% !important;\n  max-width: 240px;\n  height: auto !important;\n  position: static !important;\n  vertical-align: bottom;\n}\n\n.button {\n  margin-top: 20px;\n}\n\n.waiting,\n.connecting,\n.canceled,\n.finished,\n.started,\n.published {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--addition-40_60);\n  font: var(--font-title-9);\n  letter-spacing: var(--font-spacing-title-9);\n  color: var(--addition-50);\n}\n\n.finished {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n}\n\n.finish-title {\n  margin-bottom: 12px;\n  color: var(--addition-50);\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n}\n\n.finish-caption {\n  display: flex;\n  align-items: center;\n}\n\n.finish-icon {\n  margin-inline-end: 4px;\n  fill: currentColor;\n}\n\n.finish-actions {\n  margin-top: 34px;\n  display: flex;\n  flex-direction: column;\n}\n\n.publish-button {\n  margin-bottom: 26px;\n}\n\n.published-title {\n  font: var(--font-title-6);\n  color: var(--addition-50);\n  margin-bottom: 8px;\n}\n\n.published-description {\n  font: var(--font-body-5);\n  color: var(--addition-50);\n  margin-bottom: 24px;\n}\n\n.waiting > div {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font: var(--font-title-1);\n  letter-spacing: var(--font-spacing-title-1);\n  color: var(--addition-50);\n  visibility: hidden;\n  animation: countdown 1s linear forwards;\n}\n\n.waiting > div:nth-child(2) {\n  animation-delay: 1s;\n}\n\n.waiting > div:nth-child(3) {\n  animation-delay: 2s;\n}\n\n.close-button {\n  margin-top: 24px;\n}\n\n@keyframes countdown {\n  from {\n    visibility: visible;\n  }\n  to {\n    visibility: hidden;\n  }\n}\n\n.started {\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullScreen": `FullScreenView__fullScreen-e9ba18`,
	"container": `FullScreenView__container-afacea`,
	"main": `FullScreenView__main-e43c21`,
	"streamers": `FullScreenView__streamers-bb41fa`,
	"speaker": `FullScreenView__speaker-cc047e`,
	"meta": `FullScreenView__meta-c1d98c`,
	"secondary": `FullScreenView__secondary-f503ad`,
	"button": `FullScreenView__button-f15c87`,
	"waiting": `FullScreenView__waiting-b8fc9a`,
	"connecting": `FullScreenView__connecting-c56d30`,
	"canceled": `FullScreenView__canceled-ff1b39`,
	"finished": `FullScreenView__finished-ad45d1`,
	"started": `FullScreenView__started-e433c3`,
	"published": `FullScreenView__published-c14831`,
	"finish-title": `FullScreenView__finish-title-d8de29`,
	"finishTitle": `FullScreenView__finish-title-d8de29`,
	"finish-caption": `FullScreenView__finish-caption-f3650d`,
	"finishCaption": `FullScreenView__finish-caption-f3650d`,
	"finish-icon": `FullScreenView__finish-icon-af18d0`,
	"finishIcon": `FullScreenView__finish-icon-af18d0`,
	"finish-actions": `FullScreenView__finish-actions-e84977`,
	"finishActions": `FullScreenView__finish-actions-e84977`,
	"publish-button": `FullScreenView__publish-button-cd48e5`,
	"publishButton": `FullScreenView__publish-button-cd48e5`,
	"published-title": `FullScreenView__published-title-d537fa`,
	"publishedTitle": `FullScreenView__published-title-d537fa`,
	"published-description": `FullScreenView__published-description-d02cf6`,
	"publishedDescription": `FullScreenView__published-description-d02cf6`,
	"countdown": `FullScreenView__countdown-ea4c09`,
	"close-button": `FullScreenView__close-button-c3f0da`,
	"closeButton": `FullScreenView__close-button-c3f0da`
};
module.exports = ___CSS_LOADER_EXPORT___;
